var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick-view-window"},[_c('Card',{staticClass:"quick-view-window__card",attrs:{"title":_vm.$format(_vm.commonLocales.CommonQuickViewTitle)},on:{"click":_vm.handleChange}},[_c('template',{slot:"extra"},[_c('Icon',{attrs:{"type":"caret-down"}})],1)],2),_c('QuickViewDrawer',{attrs:{"drawerProps":{
			visible: _vm.isVisible,
			close: _vm.handleChange,
			destroyOnClose: true,
			placement: 'bottom',
			title: _vm.$format(_vm.commonLocales.CommonQuickViewTitle)
		},"quickViewProps":{
			quickViewType: _vm.quickViewType,
			id: _vm.id,
			extra: _vm.extra,
			loading: _vm.loading,
			contentData: _vm.contentData,
			exposurData: _vm.exposurData,
			title: _vm.$format(_vm.commonLocales.CommonQuickViewTitle)
		}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }